<template>
    <b-container fluid="xl">
        <b-row class="my-4">
            <b-col>
                <h6 class="big-bold-heading">Availability Calendar</h6>
                <span class="small-light-txt pe-2">Need Help?</span>
                <span class="blue-small-txt">Click here</span>
            </b-col>
        </b-row>
        <div class="search_product">
            <b-row>
                <b-col>
                    <h6 classs="big-bold-heading">Search Products<span>3650</span> </h6>
                    <div class="field my-3 ms-0">
                        <AutocompleteField />
                    </div>
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center">
                <b-col>
                    <div class="field">
                        <CustomDropDown placeholder="Type" />
                    </div>
                </b-col>
                <b-col>
                    <div class="field">
                        <CustomDropDown placeholder="View by" />
                    </div>
                </b-col>
                <b-col>
                    <div class="field">
                        <CustomDropDown placeholder="Stores" />
                    </div>
                </b-col>
                <b-col>
                    <div class="field">
                        <CustomDropDown placeholder="Category" />
                    </div>
                </b-col>
                <b-col>
                    <div class="field">
                        <CustomDropDown placeholder="Sub Category" />
                    </div>
                </b-col>
                <b-col>
                    <AddButton btnname="Search" />
                </b-col>
            </b-row>
        </div>
        <div class="storeslist">
            <div class="d-flex gap-3 align-items-center light-txt">
                <p>All</p>
                <p>Main Stores</p>
                <p>Sub Stores</p>
                <p>Department Stores</p>
            </div>
        </div>
    </b-container>
    <section class="calendarbg">
        <b-container fluid="xl">
            <b-row>
                <b-col lg="9" md="9" sm="8" cols="12" class="searchchip">
                    <span class="small-light-txt">Search Entries</span>
                    <Chip label="Pharmacy" removable />
                    <Chip label="Daily" removable />
                    <span class="blue-small-txt">Clear Search</span>
                </b-col>
                <b-col lg="3" md="3" sm="4" cols="12">
                    <div class="field">
                        <Calendar v-model="selectedMonth" view="month" dateFormat="mm/yy" />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="colorlisit">
                        <p><span class="available"></span>Available</p>
                        <p><span class="unavailable"></span>Unavailable</p>
                        <p><span class="limitedavail"></span>Limited Availability</p>
                        <p><span class="expecteddelivery"></span>Expected Delivery</p>
                        <p><span class="orderplaced"></span>PO/Order Placed</p>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <div class="medcalendarlist my-5">
            <div>
                <div class="d-flex" v-for="items in 10">
                    <!-- <div class="d-flex"> -->
                    <div class="medlistleftborder">
                        <p class="medicinename">EMSITA 100MG TAB 10’S</p>
                        <p class="light-txt">Total:300</p>
                    </div>
                    <div class="bold-heading medlistrightborder">
                        <p class="medlistrborderbottom">Available</p>
                        <p class="medlistrborderbottom">Transferred</p>
                        <p class="soldlist">Sold</p>
                    </div>
                </div>
            </div>
            <div>
                <div class="medvalueslist">
                    <!-- <p class="medmonth" v-for="items in 31">
                        <span>01</span>
                        <span class="small-light-txt">Mon</span>
                    </p> -->
                    <p class="medmonth" v-for="item in dateArray" :key="item.date">
                        <span>{{ item.date }}</span>
                        <span class="small-light-txt">{{ item.day }}</span>
                    </p>
                </div>
                <div v-for="items in 10">
                    <div class="medvalueslist">
                        <p class="medvalues" v-for="items in 31">
                            235
                        </p>
                        <!-- <p class="medvalues" v-for="(item, index) in 31" :key="index" :class="{
                            availablevalue: isAvailable(index + 1),
                            unavailablevalue: !isAvailable(index + 1),
                            limitedavailvalue: isLimitedAvail(index + 1),
                            expecteddeliveryvalue: isExpectedDelivery(index + 1),
                            orderplacedvalue: isOrderPlaced(index + 1)
                        }">
                            235
                        </p> -->
                    </div>
                    <div class="medvalueslist">
                        <p class="medvalues" v-for="items in 31">
                            235
                        </p>
                    </div>
                    <div class="medvalueslist">
                        <p class="medvalues" v-for="items in 31">
                            235
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script lang="ts">
import { defineComponent, ref, computed, Ref } from "vue";
import AutocompleteField from "../../../../components/FormComponents/AutoComplete.vue"
import CustomDropDown from '../../../../components/FormComponents/Dropdown.vue';
export default defineComponent({
    components: {
        AutocompleteField,
        CustomDropDown
    },
    setup() {
        const selectedMonth: any = ref(new Date());

        // Define the type for the dateArray
        interface DateItem {
            date: number;
            day: string;
        }
        // Compute the array of dates and days for the selected month
        const dateArray = computed<DateItem[]>(() => {
            const year = selectedMonth.value.getFullYear();
            const month = selectedMonth.value.getMonth();
            const daysInMonth = new Date(year, month + 1, 0).getDate();
            const result: DateItem[] = [];

            for (let i = 1; i <= daysInMonth; i++) {
                const date = new Date(year, month, i);
                const day = date.toLocaleDateString('en-US', { weekday: 'short' });
                result.push({ date: i, day });
            }

            return result;
        });
        return {
            selectedMonth,
            dateArray
        }
    }

})

</script>




<style type="scss" scoped>
.search_product {
    background: #323232;
    padding: 15px;

    h6 {
        color: #FFFFFF;

        span {
            font-size: 14px;
            padding-left: 5px;
            color: #999999;
            font-weight: normal;
        }
    }
}

.storeslist {
    background: #000000;
    padding: 15px;
}

.calendarbg {
    background: #F8F9FE;
    padding: 15px;
}

.searchchip {
    display: flex;
    align-items: center;
    gap: 10px;
}



.colorlisit {
    font-size: 12px;
    display: flex;
    gap: 10px;
    float: inline-end;

    .available {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background: #9DC384;
        margin-right: 10px;
    }



    .unavailable {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background: #D16D6A;
        margin-right: 10px;
    }



    .limitedavail {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background: #F2A93B;
        margin-right: 10px;
    }

    .expecteddelivery {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background: #0148E2;
        margin-right: 10px;
    }

    .orderplaced {
        width: 12px;
        height: 12px;
        display: inline-block;
        border-radius: 50%;
        background: #3096FF;
        margin-right: 10px;
    }
}

.medicinename {
    font-size: 12px;
    font-weight: 600;
}

.medlistleftborder {
    border: 1px solid #e1e1e1;
    border-right: none;
    padding: 10px;
    width: max-content;
}

.medlistrightborder {
    border: 1px solid #e1e1e1;
    width: max-content;
}

.medlistrborderbottom {
    border-bottom: 1px solid #e1e1e1;
    padding: 10px;
}

.soldlist {
    padding: 10px;
}

.medvalues {
    border: 1px solid #e1e1e1;
    min-width: 50px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.medmonth {
    border: 1px solid #e1e1e1;
    min-width: 50px;
    height: 43px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.medcalendarlist {
    display: flex;

    >div:nth-child(1) {
        width: 20%;
        margin-top: 42px;
    }

    >div:nth-child(2) {
        width: 80%;
        overflow: auto;
    }
}

.medvalueslist {
    display: flex;
}

.availablevalue {
    background: #9DC384;
}

.unavailablevalue {
    background: #D16D6A;
}

.limitedavailvalue {
    background: #F2A93B;
}

.expecteddeliveryvalue {
    background: #0148E2;
}

.orderplacedvalue {
    background: #3096FF;
}
</style>